import { type RefObject } from 'react';

import { confluenceLocalStorageInstance } from '@confluence/storage-manager/entry-points/storageInstance.ts';
import { PERSISTED_KEYS_ON_SERVER } from '@confluence/storage-manager/entry-points/LocalStorageKeys.ts';
import { fg } from '@confluence/feature-gating';

/**
 * Retrieves the persisted ghost text for QuickFind search input.
 * Prioritizes DOM value (from SSR) over localStorage to preserve hydration consistency.
 *
 * @param inputRef - Optional ref to the search input element. When provided, reads from the ref instead of using document.querySelector
 * @returns The ghost text string or undefined if not available
 */
export const getPersistedGhostText = (
	inputRef?: RefObject<HTMLInputElement> | null,
): string | undefined => {
	if (!fg('quickfind-ghosttext')) {
		return undefined;
	}

	let ghostText: string | undefined;

	const searchInput = inputRef?.current;
	if (
		typeof HTMLInputElement !== 'undefined' &&
		searchInput instanceof HTMLInputElement &&
		searchInput?.placeholder
	) {
		ghostText = searchInput.placeholder;
	}
	// If found in DOM/ref and valid, use it
	if (ghostText && ghostText.length > 0) {
		return ghostText;
	}

	return confluenceLocalStorageInstance.getItem(
		PERSISTED_KEYS_ON_SERVER.PERSISTED_PLATFORM_QUICKFIND_GHOSTTEXT,
	);
};
